import {useEffect, useState} from 'react';
import {Col, Input, Row} from 'antd';
import Text from 'antd/es/typography/Text';

interface DailyExerciseSearchProps {
  onSearch: (searchTerm: string) => void;
  onClear: () => void;
  isLoading?: boolean;
}

export const DailyExerciseSearch = ({
  onSearch,
  onClear,
  isLoading = false,
}: DailyExerciseSearchProps) => {
  const [searchValue, setSearchValue] = useState<string>('');
  const [debouncedValue, setDebouncedValue] = useState<string>('');

  // Debounce search input - wait 300ms after user stops typing
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(searchValue);
    }, 300);

    return () => {
      clearTimeout(timer);
    };
  }, [searchValue]);

  // Trigger search when debounced value changes
  useEffect(() => {
    if (debouncedValue.length >= 3) {
      onSearch(debouncedValue);
    } else if (debouncedValue.length === 0) {
      onClear();
    }
  }, [debouncedValue, onSearch, onClear]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
  };

  const handleClear = () => {
    setSearchValue('');
    setDebouncedValue('');
    onClear();
  };

  return (
    <Row
      style={{
        margin: 20,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}>
      <Col>
        <Text style={{fontWeight: 'bold'}}>
          Search by daily exercise name (Case sensitive)
        </Text>
        <Input
          style={{marginTop: 10, width: '100%', minWidth: 300}}
          placeholder="Daily exercise name (Case sensitive)"
          value={searchValue}
          onChange={handleInputChange}
          allowClear
          onClear={handleClear}
          loading={isLoading}
          suffix={
            isLoading ? (
              <span style={{fontSize: 12, color: '#999'}}>Searching...</span>
            ) : null
          }
        />
        {searchValue.length > 0 && searchValue.length < 3 && (
          <Text
            type="secondary"
            style={{fontSize: 12, marginTop: 5, display: 'block'}}>
            Type at least 3 characters to search
          </Text>
        )}
      </Col>
    </Row>
  );
};
